import React from 'react';
import ReactTooltip from 'react-tooltip';
import ReactLoading from 'react-loading';

const Submits = (props) => {
    const {
        hasEditingPermission,
        creatingNewAssignment,
        isDeleteOk,
        isSaveOk,
        hasAssignmentEnded,
        hasAsignmentStarted,
        handleClose,
        handleSave,
        isSaving,
        isDeleting,
        isBlgDateNotLatest,
        setIsDeleteModalOpen,
    } = props;
    const loaderHeight = 28;
    const loaderWidth = loaderHeight;

    if (!hasEditingPermission) {
        return null;
    } else if (hasAssignmentEnded) {
        return (
            <>
                <div className='dropdown-divider' />
                <div className='text-muted'>Det går inte att redigera avslutade uppdrag.</div>
            </>
        );
    } else if (isBlgDateNotLatest) {
        return (
            <>
                <div className='dropdown-divider' />
                <div className='text-muted'>Bara det senaste beläggningsarket kan redigeras.</div>
            </>
        );
    }

    const deleteButton = creatingNewAssignment ? null : (
        <>
            <button
                type='button'
                title='Ta bort'
                className='btn btn-sm'
                onClick={isDeleteOk ? () => setIsDeleteModalOpen(true) : null}
                data-tip={hasAsignmentStarted ? 'Det går inte att ta bort påböjade uppdrag.' : null}
                style={{ cursor: isDeleteOk ? 'pointer' : 'default' }}>
                {isDeleting ? (
                    <ReactLoading type={'bars'} className='loader' height={loaderHeight} width={loaderWidth} color={'#262f3d'} />
                ) : (
                    <i className='oi oi-trash' style={{ opacity: isDeleteOk ? 1 : 0.1 }} />
                )}
            </button>
            <ReactTooltip
                type='light'
                effect='solid'
                place='bottom'
                event='click'
                globalEventOff='click'
                border={true}
                borderColor='#C0C0C0'
                html={true}
            />
        </>
    );

    return (
        <>
            <div className='dropdown-divider' />
            {hasAsignmentStarted && <div className='text-muted'>Bara slutveckan ändras på påbörjade uppdrag.</div>}
            <div className='d-flex justify-content-between align-items-center'>
                <button type='button' className='btn btn-danger text-button' onClick={handleClose} aria-label='Close'>
                    <span aria-hidden='true'>Avbryt</span>
                </button>
                {deleteButton}
                <button type='button' className='btn btn-success text-button' disabled={!isSaveOk} onClick={handleSave}>
                    {isSaving ? (
                        <ReactLoading type={'bars'} className='loader' height={loaderHeight} width={loaderWidth} color='#F5F5F5' />
                    ) : (
                        <span aria-hidden='true'>Spara</span>
                    )}
                </button>
            </div>
        </>
    );
};

export default Submits;
